import type { MetadataTypeInfo } from "../contracts/utils/metadata/MetadataTypeInfo";
import { BacklogError } from "../errors/BacklogError";
import { MetadataPropertyInfo as MetadataPropertyInfoImpl } from "../utils/metadata/MetadataPropertyInfo";
import { MetadataPropertyInfoTypeType } from "../utils/metadata/MetadataPropertyInfoTypeType";
import { MetadataTypeInfo as MetadataTypeInfoImpl } from "../utils/metadata/MetadataTypeInfo";
import type { EntityMetadataJson, MetadataJsonTypeInfo } from "./MetadataJson";

const entity_property_metadata = new (class {
	private init = false;
	private entity_property = new Map<string, EntityMetadataJson>();

	addEntityProperty(entity_property: Map<string, EntityMetadataJson>) {
		this.entity_property = new Map([
			...this.entity_property,
			...entity_property,
		]);
		this.init = true;
	}

	getEntityProperty(path: string): EntityMetadataJson | undefined {
		if (!this.init) {
			throw new BacklogError(
				"Metadata not loaded: To use metadata, you need to call `loadBacklogMetadata()` beforehand.",
			);
		}
		const prop = this.entity_property.get(path);
		return prop;
	}

	createMetadataTypeInfo<T>(
		type_info_list: MetadataJsonTypeInfo[],
	): MetadataTypeInfo<T>[] {
		return type_info_list.map(
			(v) =>
				new MetadataTypeInfoImpl(
					v.properties.map(
						(p) =>
							new MetadataPropertyInfoImpl(
								p.name as keyof T,
								p.types.map((t) => new MetadataPropertyInfoTypeType(t)),
								p.optional,
							),
					),
				),
		);
	}
})();

export function registerEntityMetadata(
	callback: () => Map<string, EntityMetadataJson>,
) {
	entity_property_metadata.addEntityProperty(callback());
}

export function getEntityPropertyMetadata(): {
	getEntityProperty(path: string): EntityMetadataJson | undefined;
	createMetadataTypeInfo<T>(
		type_info_list: MetadataJsonTypeInfo[],
	): MetadataTypeInfo<T>[];
} {
	return entity_property_metadata;
}
